import { Trans } from '@lingui/macro'
import { MenuItem, Select } from '@material-ui/core'
import React from 'react'
import { EAccountStatus } from 'shopify-payment-core'

import { AccountStatusDisplay } from './AccountStatus'

interface IProps {
  status: Maybe<EAccountStatus>
  onChange(status: EAccountStatus): void
}

// extract list of statuses in a defined order
const statuses: EAccountStatus[] = Object.keys(EAccountStatus)
  .filter(s => isNaN(parseInt(s, 10)))
  .map(s => EAccountStatus[s])

export const AccountStatusFilter: React.FC<IProps> = ({ status, onChange }) => {
  return (
    <Select
      fullWidth
      value={status || ''}
      onChange={ev => {
        onChange((ev.target.value as unknown) as EAccountStatus)
      }}
    >
      <MenuItem value="">
        <em>
          <Trans>Vše</Trans>
        </em>
      </MenuItem>
      {statuses.map(st => (
        <MenuItem value={st} key={st}>
          <AccountStatusDisplay status={st} />
        </MenuItem>
      ))}
    </Select>
  )
}
